import { render, staticRenderFns } from "./PhoneOptionAttention.vue?vue&type=template&id=0388c376&scoped=true&"
import script from "./PhoneOptionAttention.vue?vue&type=script&lang=ts&"
export * from "./PhoneOptionAttention.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneOptionAttention.vue?vue&type=style&index=0&id=0388c376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388c376",
  null
  
)

export default component.exports